import { PaloPositionDescription, PaloPositionDescriptionProps } from '@synergy/components-palo';
import { ReactElement } from 'react';

import { useAppSelector } from '../../../store/use-appstate-selector';

/**
 * The description under a position's name, counted against the limit the PDF
 * prints position texts to — that limit comes from the settings (#2225, #2257).
 */
export const PaloPositionText = (props: Omit<PaloPositionDescriptionProps, 'printLimit'>): ReactElement => {
    const printLimit = useAppSelector(state => state.settings.printCharacterLimit) ?? undefined;

    return <PaloPositionDescription {...props} printLimit={printLimit} />;
};
